import React, { useState } from 'react';
import './AgentShared.css';

/**
 * Agree / Disagree feedback control used on individual reviewer issues
 * in both the grant agent and paper agent panels.
 *
 * Props:
 *   feedback   – { verdict: 'agree'|'disagree'|'', comment: '' } or null
 *   onFeedback – (fb) => void  called on every change
 */
export default function FeedbackButtons({ feedback, onFeedback }) {
  const verdict = feedback?.verdict || null;
  const [editingComment, setEditingComment] = useState(false);
  const [draft, setDraft] = useState(feedback?.comment || '');

  const handleVerdict = (v) => {
    if (v === verdict) {
      onFeedback({ verdict: '', comment: '' });
      setEditingComment(false);
    } else {
      if (v === 'disagree') setEditingComment(true);
      else setEditingComment(false);
      onFeedback({ verdict: v, comment: v === 'agree' ? '' : (feedback?.comment || '') });
    }
  };

  return (
    <div className="ga-feedback">
      <div className="ga-feedback-btns">
        <button
          className={`ga-feedback-btn ga-feedback-btn--agree${verdict === 'agree' ? ' ga-feedback-btn--active' : ''}`}
          onClick={() => handleVerdict('agree')}
          title="I'll address this"
        >✓ Agree</button>
        <button
          className={`ga-feedback-btn ga-feedback-btn--disagree${verdict === 'disagree' ? ' ga-feedback-btn--active' : ''}`}
          onClick={() => handleVerdict('disagree')}
          title="This doesn't apply"
        >✗ Disagree</button>
      </div>
      {(editingComment || verdict === 'disagree') && (
        <textarea
          className="ga-feedback-comment"
          value={editingComment ? draft : (feedback?.comment || '')}
          onChange={e => setDraft(e.target.value)}
          onFocus={() => { setDraft(feedback?.comment || ''); setEditingComment(true); }}
          onBlur={() => {
            onFeedback({ verdict: 'disagree', comment: draft });
            setEditingComment(false);
          }}
          placeholder="Why do you disagree? (optional)"
          rows={2}
        />
      )}
    </div>
  );
}
